import './navigable-header-section.scss';

(($) => {
	$(document).ready(function () {
		$('.navigable-header-section__bubbleLink').click(function (e) {
			if (
				$(this).attr('href').startsWith('#') &&
				$(this).attr('href').length > 1
			) {
				e.preventDefault();
				const target = $(this.hash);

				const mobileLimit = 425;
				const headerHeight = 144;
				const mobileHeaderHeight = 48;
				const offset =
					$(window).width() <= mobileLimit
						? mobileHeaderHeight
						: headerHeight;
				$('html, body').animate(
					{
						scrollTop: target.offset().top - offset,
					},
					100
				);
			} else if (
				$(this).attr('href').startsWith('#') &&
				$(this).attr('href').length === 1
			) {
				e.preventDefault();
			}
		});


		$('.navigable-header-section__link').click(function (e) {
			if (
				$(this).attr('href').startsWith('#') &&
				$(this).attr('href').length > 1
			) {
				e.preventDefault();
				const target = $(this.hash);

				const mobileLimit = 425;
				const headerHeight = 144;
				const mobileHeaderHeight = 48;
				const offset =
					$(window).width() <= mobileLimit
						? mobileHeaderHeight
						: headerHeight;
				$('html, body').animate(
					{
						scrollTop: target.offset().top - offset,
					},
					100
				);
			} else if (
				$(this).attr('href').startsWith('#') &&
				$(this).attr('href').length === 1
			) {
				e.preventDefault();
			}
		});
	});
})(jQuery);
